export default __webpack_public_path__ + "static/Inter.var-c3f97a25f56b5b416e49398b8144b0b1.woff2";